export function getRandomItem(array: any[]) {
    return array[Math.floor(Math.random() * array.length)];
}

export function getLastItem(array: any[]) {
    if (array.length) return array[array.length - 1];

    return null;
}
